import { useCallback } from 'react';

import { RootState } from '@/store';

import { useAppDispatch, useAppSelector } from '@/store/hooks/index';
import { AuthStoreState, SET_IS_JWT_LOADING } from '@/store/slices/auth.slice';

export const useAuthStore = () => {
  const { isJwtLoading } = useAppSelector((state: RootState) => state.auth);
  const dispatch = useAppDispatch();

  const setIsJwtLoading = useCallback(
    (data: AuthStoreState['isJwtLoading']) =>
      dispatch(SET_IS_JWT_LOADING(data)),
    [dispatch],
  );

  return { isJwtLoading, setIsJwtLoading };
};
